import React, { useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { updateFacility } from '../../../actions/facilitiesActions'
import Button from '../../utils/Button'

const Description = () => {
  const dispatch = useDispatch()
  const node = useRef()

  const facility = useSelector(store => store.facilities.facility)
  const adminUser = useSelector(store => store.user.admin)

  const [editing, setEditing] = useState(false)

  const handleSave = () => {
    dispatch(updateFacility(facility.id, { description: node.current.innerText }))
    setEditing(false)
  }

  return (
    <div className="mt-6">
      <div
        className="prose-lg"
        ref={node}
        contentEditable={adminUser}
        suppressContentEditableWarning={true}
        onInput={() => setEditing(true)}
      >
        {facility.description &&
          facility.description.split('\n\n').map((item, key) => (
            <p key={key}>
              {item.split('\n').map((line, lineKey) => (
                <span key={lineKey}>
                  {line}
                  {line.length > 0 && <br />}
                </span>
              ))}
            </p>
          ))}

        {adminUser && !facility.description && <p>[Edit]</p>}
      </div>
      {editing && (
        <Button small onClick={handleSave}>
          Save Description
        </Button>
      )}
    </div>
  )
}

export default Description
